import React from 'react';
import SporterMedicalCard from 'containers/pages/rehab/SporterMedicalCard';

const PersonMedicalTab = () => {
  return <SporterMedicalCard />;
};

export default PersonMedicalTab;
